import script from "./BCCell.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCCell.vue?vue&type=script&lang=ts&setup=true"

import "./BCCell.vue?vue&type=style&index=0&id=1329c6d4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1329c6d4"]])

export default __exports__